
import * as Icon from 'base/ui/components/Icons';

import { Checkbox, Divider, Form, Input, Modal, Select, Space, Tooltip, message } from 'antd';
import { DataSearchAccount, DataSearchPage, statusList } from '../model';
import { PAGE_SIZE_DEFAULT, PAGE_SIZE_OPTION, SYSTEM_TITLE } from 'utils/constants';
import { SearchBox, SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { accountPresenter, accountStore, menuPresenter, menuStore, pagePresenter, pageStore, userStore } from 'stores/root_store';
import { useEffect, useRef, useState } from 'react';

import BoxContainer from 'base/ui/components/BoxContainer';
import CustomBreadcrumb from 'base/ui/components/CustomBreadcrumb';
import CustomButton from 'base/ui/components/Button';
import CustomInput from 'base/ui/components/CustomInput';
import CustomProTable, { tablePagination } from 'base/ui/components/CustomTable';
import CustomSelect from 'base/ui/components/CustomSelect';
import { DataAccount } from 'services/RawData/account_services';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { FaKey } from 'react-icons/fa';
import { HiSearch } from 'react-icons/hi';
import { ActionType, ProColumns } from '@ant-design/pro-components';
import { observer } from 'mobx-react';
import { Link, useNavigate } from 'react-router-dom';
import { usePermission } from 'hooks/usePermission';
import { useTranslation } from 'react-i18next';
import CustomButtonIcon from 'base/ui/components/Button/buttonIcon';
import { PageModel } from 'services/RawData/page_services';
import { MenuModel } from 'services/RawData/menu_services';
import { SearchModel } from 'pages/model';
import { cloneDeep } from 'lodash';

const { confirm } = Modal;

const menuPage = () => {
    return observer(() => {
        usePermission('INDEX'); // Kiểm tra xem được quyền truy cập vào trang

        const { t } = useTranslation();

        const pagetitle = "Danh mục";
        document.title = pagetitle + ' - ' + SYSTEM_TITLE;
        const navigate = useNavigate();
        const [form] = Form.useForm();
        // state ===============================================================================
        const [openDrawer, setOpenDrawer] = useState(false);

        // Columns table title
        const defaultColumn: ProColumns<MenuModel>[] = [
            // stt
            {
                title: t('permission.account.stt'),
                dataIndex: 'stt',
                key: 'stt',
                width: 60,
                align: 'center',
                render: (text) => <div className="!text-center">{text}</div>,
                fixed: 'left',
            },
            // Tên danh mục
            {
                title: "Tên danh mục",
                dataIndex: 'menuName',
                key: 'menuName',
                width: 350,
            },
            {
                title: "Thứ tự",
                dataIndex: 'orderIndex',
                key: 'orderIndex',
                width: 70,
                onCell: () => ({
                    className: 'text-right'
                })
            },
            {
                title: "Icon",
                dataIndex: 'icon',
                key: 'icon',
                width: 70,
                onCell: () => ({
                    className: 'text-center'
                }),
                render: (text, record) => {
                    return text !== "-" ? <i className={`${text}`}></i> : text
                }
            },
            // Chức năng
            {
                title: t('permission.account.actions'),
                dataIndex: '',
                key: '',
                width: 150,
                className: '!rounded-none !py-1',
                fixed: 'right',
                align: 'center',
                render: (_, record) => {
                    return (
                        <div className="w-full flex items-center justify-center gap-x-1">
                            {userStore.userPermission?.includes('EDIT') ? (
                                <Tooltip title={t('btn.edit')}>
                                    <Link to={`${record.menuId}`}>
                                        <CustomButtonIcon color="#007BF1">
                                            <Icon.PencilEdit className="!fill-[#007BF1]" width="14" height="14" />
                                        </CustomButtonIcon>
                                    </Link>
                                </Tooltip>
                            ) : null}
                            {userStore.userPermission?.includes('DELETE') ? (
                                <Tooltip title={t('btn.delete')}>
                                    <CustomButtonIcon
                                        color="#FC5C5E"
                                        onClick={() => {
                                            showDeleteConfirm(record);
                                        }}
                                    >
                                        <Icon.Trash className="!fill-[#FC5C5E]" width="14" height="14" />
                                    </CustomButtonIcon>
                                </Tooltip>
                            ) : null}

                        </div>
                    );
                },
            },
        ];
        // Custom default columns table with resizeable
        const [columns, setColumn] = useState<ProColumns<MenuModel>[]>(defaultColumn);
        // Loading all page
        const [loading, setLoading] = useState(false);
        const tableRef = useRef<ActionType>();

        // Data search
        const [dataSearch, setDataSearch] = useState<SearchModel>({
            paging: {
                pageIndex: 1,
                pageSize: PAGE_SIZE_DEFAULT,
                orderBy: undefined,
                orderByDesc: undefined,
            },
        });
        const [listData, setListData] = useState<MenuModel[]>([]);

        // function open hide drawer ===========================================================
        const showDrawer = () => {
            setOpenDrawer(true);
        };

        const onCloseDrawer = () => {
            setOpenDrawer(false);
        };

        // Call api search Data
        const getDataSearch = async (dataSearch: DataSearchPage) => {
            await menuPresenter.getListMenu(menuStore, dataSearch);
            if (menuStore.searchMenuRes.isSuccess) {
                const cloneData = cloneDeep(menuStore.searchMenuRes.data)
                setListData(cloneData);
                return cloneData
            }
            return []
        };

        // Handle click button search
        const handleSearch = async (values: any) => {
            setLoading(true);
            const tempDataSearch = {
                paging: {
                    ...dataSearch.paging,
                    pageIndex: 1,
                },
                ...values,
            };
            // set pageIndex 1 when search form
            setDataSearch(tempDataSearch);
            tableRef.current?.reload()
            setLoading(false);
            onCloseDrawer();
        };

        // scroll to top
        useEffect(() => {
            window.scrollTo(0, 0);
        }, []);

        // initialValues of form search
        const initialValues = {};

        // Call api delete
        const handleClickDelete = async (menuid: string) => {
            setLoading(true);
            if (menuid) {
                const result = await menuPresenter.deleteMenu(menuid);
                if (result) {
                    // Call list branch after change
                    // await getDataSearch(dataSearch);
                    tableRef.current?.reload()
                }
            }
            setLoading(false);
        };

        // Ui modal confirm delete store
        const showDeleteConfirm = (item: MenuModel) => {
            confirm({
                title: `${t('btn.delete')} "${item.menuName}"`,
                icon: <ExclamationCircleFilled />,
                content: `${t('message.question-delete')} "${item.menuName}"`,
                okText: t('btn.delete'),
                okType: 'danger',
                cancelText: t('btn.cancel'),
                className: 'custom__modalconfirm--delete',
                onOk() {
                    handleClickDelete(item.menuId || '');
                },
                onCancel() { },
            });
        };

        return (
            <div className="w-full">
                {/* ================ Breadcrumb =============== */}
                <CustomBreadcrumb
                    pagetitle={[{ title: pagetitle, link: '/Permission/Account' }]}
                    extra={
                        <>
                            <CustomButton onClick={showDrawer} type="primary" color="#EFF4F9" className="!px-0 w-8">
                                <Icon.Filter className="fill-primary" />
                            </CustomButton>
                            {userStore.userPermission?.includes('EXPORT') ? (
                                <CustomButton
                                    onClick={() => {
                                        navigate('create');
                                    }}
                                    icon={<Icon.Download className={'!fill-dark'} />}
                                >
                                    Export
                                </CustomButton>
                            ) : null}
                            {userStore.userPermission?.includes('IMPORT') ? (
                                <CustomButton
                                    onClick={() => {
                                        navigate('create');
                                    }}
                                    icon={<Icon.Upload />}
                                >
                                    Import
                                </CustomButton>
                            ) : null}
                            {userStore.userPermission?.includes('CREATE') ? (
                                <CustomButton
                                    onClick={() => {
                                        navigate('create');
                                    }}
                                    type="primary"
                                    icon={<Icon.Plus className="!fill-white" />}
                                >
                                    {t('btn.add')}
                                </CustomButton>
                            ) : null}
                        </>
                    }
                />
                {/* Table */}
                <BoxContainer>
                    <CustomProTable<MenuModel>
                        columns={columns}
                        handleResize={() => { }}
                        rowKey="stt"
                        size="small"
                        bordered
                        search={false}
                        actionRef={tableRef}
                        request={async (params = {}, sort, filter) => {
                            const data = await getDataSearch({
                                ...dataSearch,
                                paging: {
                                    ...dataSearch.paging,
                                    orderBy:
                                        Object.values(sort)[0] === "ascend"
                                            ? `${Object.keys(sort)[0].split(",").pop()}`
                                            : undefined,
                                    orderByDesc:
                                        Object.values(sort)[0] === "descend"
                                            ? `${Object.keys(sort)[0].split(",").pop()}`
                                            : undefined,
                                },
                            });
                            if (Object.values(sort).length) {

                                setDataSearch({
                                    ...dataSearch,
                                    paging: {
                                        ...dataSearch.paging,
                                        orderBy:
                                            Object.values(sort)[0] === "ascend"
                                                ? `${Object.keys(sort)[0].split(",").pop()}`
                                                : undefined,
                                        orderByDesc:
                                            Object.values(sort)[0] === "descend"
                                                ? `${Object.keys(sort)[0].split(",").pop()}`
                                                : undefined,
                                    },
                                });
                            }
                            return {
                                data: data,
                                success: menuStore.searchMenuRes?.isSuccess
                            };

                        }}
                        dataSource={listData}
                        scroll={{ y: 500 }}
                        pagination={{
                            ...tablePagination(dataSearch, setDataSearch),
                            total: menuStore.searchMenuRes?.paging?.recordsTotal,
                        }}
                        options={false}
                    />
                </BoxContainer>
                {/* Form search */}
                <SearchBox
                    className="lg:!w-[35%]"
                    footer={[
                        <div key="footer" className="flex justify-end">
                            <CustomButton
                                type="primary"
                                icon={<HiSearch />}
                                htmlType="submit"
                                onClick={() => {
                                    form.submit();
                                    onCloseDrawer();
                                }}
                            >
                                {t('btn.search')}
                            </CustomButton>
                        </div>,
                    ]}
                    onClose={onCloseDrawer}
                    open={openDrawer}
                >
                    <SearchForm column="col-1" initialValues={initialValues} form={form} onFinish={handleSearch}>
                        {/* Tên chức năng */}
                        <SearchItem label={"Tên danh mục"} name={'menuName'}>
                            <Input />
                        </SearchItem>


                    </SearchForm>
                </SearchBox>
            </div>
        );
    });
};

export default menuPage;
